import { Selector, createSelector } from "reselect";

import { Filter, GroupFilterEnum, IFilters, notTaggedFilter } from "constants/filters";
import { Right } from "constants/right";
// FIXME: Fix this the next time the file is edited.
// @ts-expect-error TS(6133): 'alphabeticalSortBySelector' is declared but its v... Remove this comment to see the full error message
// eslint-disable-next-line @typescript-eslint/no-unused-vars
import { alphabeticalSortBySelector } from "helpers/sort";
import { IStoreState } from "interfaces/storeState";
import { IAgent, IWithAgentsState, selectAgents } from "store/entities/agents";
import { ICustomView, ICustomViewWithStatus } from "store/entities/custom-views/interfaces";
// FIXME: Fix this the next time the file is edited.
// @ts-expect-error TS(6133): 'IEntityCollectionState' is declared but its value... Remove this comment to see the full error message
// eslint-disable-next-line @typescript-eslint/no-unused-vars
import { IEntityCollectionState } from "store/entities/reducer";
import { ITag, selectTags } from "store/entities/tags";
import { ITeam, selectCurrentAgentTeams, selectTeams } from "store/entities/teams";
import { IWithSessionState, hasRight } from "store/features/session";

import { ICustomViewState } from "./reducer";

export interface IWithCustomViewsState {
  entities: {
    customViews: ICustomViewState;
  };
}

// FIXME: Fix this the next time the file is edited.
// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
export function selectCustomViews(state: IWithCustomViewsState) {
  return state.entities.customViews;
}

export const selectCustomViewsAlphabetically = createSelector(selectCustomViews, views =>
  views.order.map(viewID => views.data[viewID])
);

const isMissingFilter = (
  customViewFilters: IFilters,
  filter: Filter.Tag | Filter.Agent | Filter.Group,
  filterValues: Record<string, unknown>
): boolean => {
  const filterValue = customViewFilters[filter];

  const isMyTeamsFilter =
    filter === Filter.Group &&
    Array.isArray(filterValue) &&
    filterValue.length === 1 &&
    filterValue[0] === "MY_TEAMS";

  const values: Record<string, unknown> = { ...filterValues };

  if (filter === Filter.Agent) {
    values.ME = {};
  }

  if (isMyTeamsFilter) {
    return false;
  }

  if (Array.isArray(filterValue)) {
    return filterValue.some(value => values[value] === undefined);
  }

  return false;
};

const hasOnlyInaccessibleGroups = (
  filters: IFilters,
  allTeams: Record<string, ITeam>,
  accessibleTeamIds: Set<string>
): boolean => {
  const groupFilter = filters[Filter.Group];
  if (!Array.isArray(groupFilter) || groupFilter.length === 0) {
    return false;
  }
  const existingTeamIds = groupFilter.filter(
    groupId => groupId !== GroupFilterEnum.MyTeams && allTeams[groupId] !== undefined
  );
  if (existingTeamIds.length === 0) {
    return false;
  }
  return existingTeamIds.every(groupId => !accessibleTeamIds.has(groupId));
};

export const selectCustomViewsWithStatusAlphabetically: Selector<IStoreState, ICustomViewWithStatus[]> = createSelector(
  [selectCustomViewsAlphabetically, selectTags, selectTeams, selectAgents, selectCurrentAgentTeams],
  (
    customViews: ICustomView[],
    tags: Record<string, ITag>,
    teams: Record<string, ITeam>,
    agents: Record<string, IAgent>,
    currentAgentTeams: ITeam[]
  ) => {
    const tagsWithNotTagged = {
      ...tags,
      [notTaggedFilter.id]: notTaggedFilter,
    };
    const accessibleTeamIds = new Set(currentAgentTeams.map(team => team.id));

    return customViews
      .filter((customView: ICustomView) => !hasOnlyInaccessibleGroups(customView.filters, teams, accessibleTeamIds))
      .map((customView: ICustomView) => {
        const isInvalid =
          isMissingFilter(customView.filters, Filter.Tag, tagsWithNotTagged) ||
          isMissingFilter(customView.filters, Filter.Agent, agents) ||
          isMissingFilter(customView.filters, Filter.Group, teams);

        return { ...customView, invalid: isInvalid };
      });
  }
);
export function selectCanCreateCustomViews(
  state: IWithCustomViewsState & IWithSessionState & IWithAgentsState
): boolean {
  return hasRight(state, Right.CreateCustomViews);
}

// FIXME: Fix this the next time the file is edited.
// @ts-expect-error TS(6133): 'state' is declared but its value is never read.
// eslint-disable-next-line @typescript-eslint/no-unused-vars
export function selectCanSeeCustomViews(state: IWithCustomViewsState & IWithSessionState): boolean {
  return true;
}
